import React from "react";
import { ReactComponent as RemoveIcon } from "images/icons/remove.svg";
import { OutOfStockResolutionPreference } from "src/storefront/types/out_of_stock_resolution_preference";

const OutOfStockResolutionSelector = ({
  selectedOutOfStockResolutionPreference,
  onPreferenceSave,
}: {
  selectedOutOfStockResolutionPreference: OutOfStockResolutionPreference;
  onPreferenceSave: (preference: OutOfStockResolutionPreference) => void;
}) => {
  return <div className="surface" data-testid="substitutions-preference-selector">
    <div className="content">
      <div>
        <section className="container">
          <h5 className="is-size-5">Substitutions</h5>
        </section>

        <section className="container">
          <p>Choose what you would like to do if your product is unavailable</p>
        </section>

        <section className="container is-flexbox flex-column is-flex-gap-xs">
          {OutOfStockResolutionPreference.preferences.map((preference) => {
            return <label key={preference.type} htmlFor={`preference-${preference.type}`} className="radio-callout">
              <input
                id={`preference-${preference.type}`}
                data-testid={preference.type}
                type="radio"
                name="out_of_stock_preference"
                value="substitute"
                defaultChecked={preference.type == selectedOutOfStockResolutionPreference.type}
                onClick={() => onPreferenceSave(preference)}
              />
              <span>{preference.title}</span>
              <span>{preference.description}</span>
            </label>
          })}
        </section>

        <hr className="space-m-none"/>

        <section className="container">
          <p className="is-tiny-muted-text">Any substitution price difference will be refunded when the order is
            complete. If no substitutes are available then the full item value will be refunded. Refunds can take 5-7
            business days to process.</p>
        </section>

        <section className="container">
          <div className="is-flexbox justify-content-center">
            <button className="button is-full-width is-visible-above-tablet" data-action="click->popover-sheet#toggleVisibility" aria-label="Close">
              Close
            </button>
            <button className="button is-icon-only has-large-icon is-primary is-hidden-above-tablet"
                    data-action="click->popover-sheet#toggleVisibility" aria-label="Close">
              <RemoveIcon className="icon streamline-icon"/>
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
}

export { OutOfStockResolutionSelector };